import { render } from "./Cgu.vue?vue&type=template&id=69b1434e&scoped=true"
import script from "./Cgu.vue?vue&type=script&lang=js"
export * from "./Cgu.vue?vue&type=script&lang=js"

import "./Cgu.vue?vue&type=style&index=0&id=69b1434e&lang=scss&scoped=true"

import exportComponent from "/home/pomelos/Projects/stowy-web-prod/stowy-web/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b1434e"]])

export default __exports__